export function formatPhoneNumber(phoneNumber){
  if(phoneNumber.length <=12){
    return phoneNumber.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3');
  }else{
    const numberWithoutDash = phoneNumber.replace(/-/g, '');
    return numberWithoutDash.slice(0,-1).replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3').replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3');
  }
  
}